import type { CourtOfficerErrors, CourtOfficerFormState } from "./types";

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const usernamePattern = /^[a-zA-Z0-9]+$/;
const phonePattern = /^\d{10}$/;
const namePattern = /^[A-Za-z]+(?:[ -][A-Za-z]+)*$/;

export function validateOfficerForm(
  form: CourtOfficerFormState,
  options: { isEditing?: boolean } = {},
) {
  const errors: CourtOfficerErrors = {};

  if (form.firstName.trim().length < 2) {
    errors.firstName = "First name must be at least 2 characters";
  } else if (!namePattern.test(form.firstName.trim())) {
    errors.firstName = "First Name should contain only alphabetic characters";
  }

  if (form.lastName.trim().length < 2) {
    errors.lastName = "Last name must be at least 2 characters";
  } else if (!namePattern.test(form.lastName.trim())) {
    errors.lastName = "Last Name should contain only alphabetic characters";
  }

  if (!emailPattern.test(form.email.trim())) {
    errors.email = "Enter a valid email address";
  }

  if (!phonePattern.test(form.phone.trim())) {
    errors.phone = "Phone number must contain exactly 10 digits";
  }

  if (form.username.trim().length < 4) {
    errors.username = "Username must be at least 4 characters.";
  } else if (form.username.trim().length > 20) {
    errors.username = "Username must not exceed 20 characters.";
  } else if (!usernamePattern.test(form.username.trim())) {
    errors.username = "Username can only contain letters and numbers.";
  }

  if (!form.role) {
    errors.role = "Select an officer role";
  }

  if (
    !options.isEditing &&
    form.courtType === "high_courts" &&
    form.role === "Judge"
  ) {
    if (!form.highCourtId) {
      errors.highCourtId = "Please select a High Court";
    } else if (!form.benchId) {
      errors.benchId = "Please select a Bench";
    }
  }

  if (
    form.courtType === "district_courts" &&
    form.role === "Judge" &&
    !form.stateName
  ) {
    errors.stateName = "Select a state for this judge";
  }

  if (
    form.courtType === "district_courts" &&
    form.role === "Judge" &&
    !form.districtId
  ) {
    errors.districtId = "Select a district for this judge";
  }

  if (!options.isEditing && form.password.trim().length < 8) {
    errors.password = "Temporary password must be at least 8 characters";
  }

  return errors;
}
